import { FormattedMessage } from 'react-intl';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { Box, Tooltip, Typography, useTheme } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { useSearchParams } from 'react-router-dom';
import { useEntityPermission } from '../../providers/EntityPermissionProvider';
import Label from './Label';
import SubSection from '../UI/SubSection';
import { useLocalization } from '../../providers/LocalizationProvider';

/*
 * typeof field?.column === 'string' is used to determine if the column is a string or a number.
 * If it's a string, we don't set gridRow, otherwise we set it to field?.row
 * This is useful for cases where you need fullwidth field and define column as "1/-1".
 */

/*
input 
{
 name:
 control: (optional)
 label:{localeId, defaultMessage},
 column:
  row: 
}
*/

function FieldWrapperVerticalV2({
  field,
  errors = [],
  customComponents = [],
  showDirtyFields = false,
  children,
  labelStyle = {},
}) {
  const { formatMessage } = useLocalization();
  const theme = useTheme();
  const {
    formState: { dirtyFields },
  } = useFormContext();
  const { isReadOnly } = useEntityPermission();
  const [urlParams] = useSearchParams();
  let showPermission = urlParams.get('permissions') || 0;

  if (showPermission) {
    showPermission = typeof field?.permission === 'string' ? 1 : 0;
  }

  const SHOW_DIRTY_FIELDS = showDirtyFields;

  const readOnly = isReadOnly(field?.permission, '');

  if (!field?.label?.localeId) {
    return children;
  }

  const ToolTipComponent = customComponents?.[field?.toolTipComponent] || null;

  return (
    <Box key={field?.name}>
      <Label
        htmlFor={field?.name.replace('.', '-')}
        style={{ display: 'block', marginBottom: '5px', ...labelStyle }}
        error={!!errors[field?.name]}
        focused={!!errors[field?.name]}
        required={field?.required && !readOnly}>
        {formatMessage({
          id: field?.label?.localeId,
          defaultMessage: field?.label?.defaultMessage,
        })}{' '}
        {parseInt(showPermission, 10) === 1 ? (
          <Typography color="warning.main">{field?.permission}</Typography>
        ) : (
          ''
        )}
        {ToolTipComponent && <ToolTipComponent />}
        {SHOW_DIRTY_FIELDS && dirtyFields?.[field?.name] && (
          <Tooltip
            placement="top"
            arrow
            title={
              <FormattedMessage id="NOT_SAVED" defaultMessage="Not Saved" />
            }>
            <span
              style={{
                float: 'right',
                marginRight: '10px',
                display: 'inline-block',
                color: theme.palette.warning.dark,
              }}>
              <FiberManualRecordIcon sx={{ fontSize: '10px' }} />
            </span>
          </Tooltip>
        )}
      </Label>
      {field?.control === 'subsection' ? (
        <SubSection>{children}</SubSection>
      ) : (
        children
      )}
    </Box>
  );
}

export default FieldWrapperVerticalV2;
